import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-game-tap",
  templateUrl: "./game-tap.component.html",
  styleUrls: ["./game-tap.component.css"],
})
export class GameTapComponent implements OnInit {
  gameTapURL: SafeResourceUrl | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer // Inject DomSanitizer
  ) {
    this.route.queryParams.subscribe((params) => {
      if ((this.router.getCurrentNavigation() as any)?.extras?.state) {
        const state = (this.router.getCurrentNavigation() as any).extras.state;
        if (state.gametap) {          
          this.gameTapURL = this.sanitizer.bypassSecurityTrustResourceUrl(
            state.gametap
          );
        }
      }
    });
  }

  ngOnInit() {
    console.log("");
  }
}
